import { Vue,Component,Emit,Watch,Prop} from 'vue-property-decorator';
import List from '@/assets/common/List/List.vue'
import NotificationPreviewModal from '@/components/Notification/NotificationPreviewModal/NotificationPreviewModal.vue'
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import moment from "moment";



type NotificationList = {
    id: string;
    title: string;
    content: string;
    publishDate: string;
    saveDate:string;
    isImportant: boolean;
    isDraft: boolean;
    selectedNotificationId : string;
};

type NotificationsGet = {
    notifications: NotificationList[];
}


export type Item = {
    id: string;
    saveDate:string;
    title: string;
    isDraft: boolean;
    isActive: boolean;
}
export type FilterArray = {
    id: string;
    title: string;
    isDraft: boolean;
    saveDate:string;
    isImportant: boolean;
    isActive: boolean;
}
@Component({
    components: {
        List,
        NotificationPreviewModal
    }
})
export default class Notification extends Vue {
    private list: any | null = null
    private items: Item[] | undefined = []
    private title = 'お知らせ'
    private searchText = ''
    private baseUrl = '/notification_register';
    private clientBaseUrl = '/notification-register'
    private activeList: 'DATE' | 'IMPORTANT' = 'DATE'
    private notifications: NotificationList[] = []
    private isLoading = false
    private headerTitle!: string
    private selectedNotification!: NotificationList
    private notificationId = ""
    private notificationTitle = ""
    private  notificationContent = ""
    private notificationPublishDate = ""
    private isImportant = false
    private isImportantOnly = false
    private isDraft = false
    private isDeletable = true
    private id =""
    private saveDate = ""
    private selectedNotificationId : string | null = null
    private isNotificationContent = false
    isShowNotificationPreviewModal = false
    private isDeletableDate = ''
    private created() {
        this.getNotifications(false)
    }

    private getNotifications(isImportantOnly: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?is_important=${isImportantOnly}`).then(res => {
            this.notifications = (toCamel(res) as NotificationsGet).notifications as NotificationList[]
        })
        .finally(() => {
            this.list = this.notifications
            this.items = this.list
        })
    }

    createNotifications() {
        this.$router.push(`${this.clientBaseUrl}/`, () => {return})
        if(store.getters.isInputChanged==false){
        this.headerTitle = "新規お知らせ"
        this.notificationId = "create"
        this.notificationTitle = ""
        this.notificationContent = ""
        this.notificationPublishDate =  ""
        this.saveDate = ""
        this.isImportant = false
        this.isDraft = true
        this.isDeletable = false
        this.isAction(this.notificationId);
        }
    }

    sentNotification(){
        if (!this.validation()) {
            return false
        }
        this.isLoading = true
        const params = {
            title: this.notificationTitle,
            content: this.notificationContent,
            publishDate: new Date(),
            saveDate: new Date(),
            isImportant: this.isImportant,
            isDraft:false
        }
        const result = window.confirm("送信しますか？")
            if(!result) {
                this.isLoading = false
                return false;
            }
        if (this.notificationId === "create") {
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((res) => {
                this.$router.push(`${this.clientBaseUrl}/${res.id}`, () => {return})
                this.getNotifications(this.isImportantOnly)
                this.setNotification(res.id);
                this.$toasted.success('送信しました。')
            })
            .catch(() => {
                this.$toasted.error('送信に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }else {
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.notificationId}`, params).then(() => {
                this.getNotifications(this.isImportantOnly)
                this.setNotification(this.notificationId);
                this.$toasted.success('送信しました。')
            })
            .catch(() => {
                this.$toasted.error('送信に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    saveDraft(){
        if (!this.validation()) {
            return false
        }
        this.isLoading = true
        const params = {
            title: this.notificationTitle,
            content: this.notificationContent,
            saveDate:new Date(),
            isImportant: this.isImportant,
            isDraft: true
        }
        if (this.notificationId === "create") {
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((res) => {
                this.$router.push(`${this.clientBaseUrl}/${res.id}`, () => {return})
                this.getNotifications(this.isImportantOnly)
                this.setNotification(res.id);
                this.$toasted.success('保存しました。')
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.notificationId}`, params).then(() => {
                this.getNotifications(this.isImportantOnly)
                this.isAction(this.notificationId);
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    
    notificationDelete(){
        this.isLoading = true
        if(!this.isDraft){
          const deleteResult = window.confirm("「送信後の削除は、運用上行ってはいけません。行った場合は、お客様から、お知らせが、見えなくなったなどのクレームが予想されます。お客様に絶対提示してはいけないお知らせを送信してしまった場合などに限ります。それ以外は、新たなお知らせを作成し、そこで訂正文を記載するようにしてください。それでも削除しますか？」")
          if(!deleteResult){
            this.isLoading = false
            return false;
          }
        }   
        const result = window.confirm("お知らせを削除します。よろしいですか。")
        if(!result) {
            this.isLoading = false
            return false;
        }
        this.$apiClient.doRequest("delete", `${this.baseUrl}/${this.notificationId}`).then(() => {
            this.getNotifications(this.isImportantOnly)
            this.$router.push(`${this.clientBaseUrl}`, () => {return})
            this.createNotifications()
            this.$toasted.success('削除しました。')
        })
        .catch(() => {
            this.$toasted.error('削除に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
    
    cancel(){
      const result = window.confirm('変更内容を破棄します。よろしいですか。')
      this.$store.dispatch('doUpdateIsInputChanged', false);
      if (result) {
       if (this.notificationId !== 'create'){
        this.setNotification(this.notificationId);
       }else{
        this.createNotifications()
       }
     }
    }

    @Watch('searchText')
    private doSearch() {
        this.init();
    }

    init() {
        const filteredByKeyword = this.searchText ? this.list?.filter((item: Item) => item.title.indexOf(this.searchText) > -1): this.list;
        const sortArray: FilterArray[] = filteredByKeyword
        if(this.activeList === 'IMPORTANT') {
            this.items = sortArray.sort((a, b) => (a.isImportant === b.isImportant ? 0 : a.isImportant ? -1 : 1));
        }else if(this.activeList === 'DATE'){
            this.items = sortArray.sort((a, b) => new Date(b.saveDate).getTime() - new Date(a.saveDate).getTime());
        }
    }

    toggleImportantItems(){
        this.isImportantOnly = !this.isImportantOnly
        this.getNotifications(this.isImportantOnly);
        this.isAction(this.notificationId);
    }

    private setNotification (id:string){
        this.$router.push(`${this.clientBaseUrl}/${id}`, () => {return})       
        this.headerTitle = "お知らせ編集"
        if(store.getters.isInputChanged==false){
        this.$apiClient.doRequest("get", `${this.baseUrl}/${id}`).then((ret) => {
            const item = this.selectedNotification = toCamel(ret) as NotificationList
            this.notificationId = item.id
            this.notificationTitle = item.title
            this.notificationContent = item.content
            if (item.publishDate) {
                const date = new Date(item.publishDate);
                this.notificationPublishDate = moment(date).format('YYYY/MM/DD HH:mm:ss')
            }else{
                this.notificationPublishDate = item.publishDate
            }
            this.saveDate = this.changeDateFormat(item.saveDate)
            this.isImportant = item.isImportant
            this.isDraft = item.isDraft
            this.isDeletableDate = item.publishDate
            this.isAction(id);
            this.isDeletableCheck(item.publishDate);
            // Set up an interval to call isDeletableCheck
            setInterval(() => {
            if(!this.isDraft && this.isDeletable){
            this.isDeletableCheck(this.isDeletableDate);
            }
            }, 1000); 
        });
      }
    }

    private isDeletableCheck(publishDate:string){
        if(publishDate){
        const publishDateObj = new Date(publishDate);
        const currentDate = new Date();
        
        // Set the time limit for deletion (10 minutes)
        const deletionTimeLimit = 10 * 60 * 1000; // 10 minutes in milliseconds

        // Check if the difference between current time and publish date is within the limit
        const isDeletable = currentDate.getTime() - publishDateObj.getTime() <= deletionTimeLimit;
        this.isDeletable = isDeletable;
        }else{
            this.isDeletable = true
        }
    }

    private isAction(id:string){
    setTimeout(() => {
        const newItems: Item[] = []
        this.items?.forEach((val) => {
            if(id === val.id){
                val.isActive = true
            }else {
                val.isActive = false
            }
            newItems.push(val)
        })
        this.items = newItems
    }, 100);
    }

    openSideBar = () => {
        if(document.body.classList.contains('sideopen')){
            document.body.classList.remove('sideopen')
        }else{
            document.body.classList.add('sideopen')
        }
    }
  
    validateInput(inputValue: any) {
        if (!inputValue.includes("<@@URL>") && !inputValue.includes("</@@URL>") && !inputValue.includes("<&&>")) {
            return true;
        }
    
        const lines = inputValue.split('\n');
        let startTagFound = false;
        let endTagFound = false;
    
        for (const line of lines) {
            let startIndex = line.indexOf('<@@URL>');
            let middleIndex = line.indexOf('<&&>');
            let endIndex = line.indexOf('</@@URL>');
    
            while (startIndex !== -1 || endIndex !== -1) {
                if (startIndex !== -1) {
                    // Start tag found, make sure it appears before middle and end tags
                    startTagFound = true;
    
                    if (middleIndex === -1 || (middleIndex < startIndex || endIndex === -1 || middleIndex > endIndex)) {
                        // Middle tag is missing or out of order, return false
                        return false;
                    }
                }
    
                if (endIndex !== -1) {
                    // End tag found, make sure it appears after middle and start tags
                    endTagFound = true;
    
                    if (middleIndex === -1 || (middleIndex < startIndex || endIndex < middleIndex)) {
                        // Middle tag is missing or out of order, return false
                        return false;
                    }
                }
    
                // Move to the next occurrence of the tags
                startIndex = line.indexOf('<@@URL>', startIndex + 1);
                middleIndex = line.indexOf('<&&>', middleIndex + 1);
                endIndex = line.indexOf('</@@URL>', endIndex + 1);
            }
        }
    
        return startTagFound && endTagFound;
    }

    validation(){
        const errmsg: string[] = []
        // 名前の入力
        if(!this.notificationTitle.trim()) {
            errmsg.push("タイトルを入力してください")
        }
        // 名前の長さ
        if(this.notificationTitle.length > 100) {
            errmsg.push(`タイトルは100文字以内で入力してください（現在は${this.notificationTitle.length}文字）`)
        }
        // 内容
        if (!this.notificationContent.trim()) {
            errmsg.push('内容を入力してください。')
        }
        else if (!this.validateInput(this.notificationContent)) {
            errmsg.push('「<@@URL>[URL]<&&>[メッセージ]</@@URL>  で記載してください。」'); 
        }
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    private changeDateFormat(inputDate: string): string {
        const utcDate = new Date(inputDate);
        const newDateFormat= moment(utcDate).format('YYYY/MM/DD HH:mm:ss')
        return newDateFormat;
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    //テキストエリアをアクティブにする
    private textareaActivated() {
        this.isNotificationContent = true;
    }
    //テキストエリアを非アクティブにする 
    private textareaDeactivated() {
        this.isNotificationContent = false;
    }

   private urlAdd() {
     const urlFormat = `<@@URL><&&></@@URL>`;
     // Get the cursor position
     const textareaRef = this.$refs.notificationTextArea as HTMLInputElement;
     if (textareaRef) {
      const cursorPosition = textareaRef.selectionStart ?? 0;

     // Add URL format at the cursor position
      this.notificationContent = this.notificationContent.substring(0, cursorPosition) + urlFormat + this.notificationContent.substring(cursorPosition);
      
     // Update the cursor position after adding the URL format
     this.$nextTick(() => {
        textareaRef.selectionStart = cursorPosition + urlFormat.length;
        textareaRef.selectionEnd = cursorPosition + urlFormat.length;
       });
    }
  }
  private notificationPreview(){
    if (!this.validation()) {
        return false
    }
   this.isShowNotificationPreviewModal = true
  }
}